import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const FoodMenu = Loadable(
	lazy(() =>
		import("./FoodMenu").then(({ FoodMenu }) => ({
			default: FoodMenu,
		}))
	)
);

const ManageFoodMenu = Loadable(
	lazy(() =>
		import("./ManageFoodMenu").then(({ ManageFoodMenu }) => ({
			default: ManageFoodMenu,
		}))
	)
);

export const foodMenuRoutes = [
	{
		path: "/food-menu",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[]}
			>
				<FoodMenu />
			</AuthorizedRoute>
		),
	},
	{
		path: `/food-menu/manage`,
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[]}
			>
				<ManageFoodMenu />
			</AuthorizedRoute>
		),
	},
	{
		path: `/food-menu/manage/:uuid`,
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[]}
			>
				<ManageFoodMenu />
			</AuthorizedRoute>
		),
	},
];
